import { useQuery } from '@tanstack/react-query';
import { getKgInsight } from '@terminal/services/insights/kg-insights-service';

export const QUERY_KEY_KG_INSIGHT = 'QUERY_KEY_KG_INSIGHT';

export const useKgInsight = (insightId: string) => {
  return useQuery({
    queryKey: [QUERY_KEY_KG_INSIGHT, insightId],
    queryFn: () => getKgInsight(insightId),
    enabled: !!insightId,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 1, // 1 hour
  });
};
